<template>
  <div class="multi-select">
    <div class="title" v-if="title">{{title}}</div>
    <ul class="list">
      <li class="item" :class="{active:selectedList.indexOf(item) > -1}" v-for="(item, idx) in items" :key="idx" @click="handleItemClick(item)">{{item.name}}</li>
    </ul>
  </div>
</template>
<script> 
/*
  props: 

  title: 选项标题
  items: 是数组类型，包含所有选项

  事件:

  change 参数：包含所有选中的条目
  
*/

export default {
  data() {
    return {
      selectedList: []
    };
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    items: {
      type: Array
    },
    selectedFilters: {
      type: Array
    }
  },
  watch: {
    'selectedFilters'(newval) {
      this.selectedList = newval;
    }
  },
  methods: {
    handleItemClick(item) {
      if (this.selectedList.indexOf(item) === -1) {
        this.selectedList.push(item);
      } else {
        this.selectedList.splice(this.selectedList.indexOf(item), 1);
      }
      this.$emit('change', this.selectedList);
    }
  },
  mounted() {
    this.selectedList = this.selectedFilters;
  }
};
</script>
<style lang="scss" scoped>
ul, li {
  margin: 0;
  padding: 0;  
  list-style: none;
}
.multi-select {
  display: flex;
  width: 100%;
  .title {
    min-width: 44px;
    height: 32px;
    line-height: 32px;
    align-items: center;
    font-weight: 600;
    font-size: 14px;
    color: #464d6c;
  }
  ul.list {
    display: flex;
    flex-flow: row;
    flex-wrap: wrap;
    .item {
      height: 24px;
      margin: 5px 10px 5px 0;
      padding: 2px 4px;
      font-size: 14px;
      color: #464d6c;
      border-radius: 2px;
      cursor: pointer;
      &:hover {
        color: #45a8cc !important;
        background-color: #ffffff;
        border-radius: 2px;
        cursor: pointer;
      }
    }
  }
}
</style>
